<template>
	<div class="v-label-group" ref="input">
    <v-label v-for="(label,i) in value" :key="i" @remove="remove(i)" removable>{{label}}</v-label>
		<v-label class="add" v-if="value.length<maxCount">
      <div class="inner" placeholder="添加标签" @keyup.enter="add" @keypress="text=$event.target.innerText.trim()" ref="inner" contenteditable></div>
		</v-label>
	</div>
</template>

<script>
export default {
  props: {
    value: {
      default() {
        return [];
      }
    },
    maxCount: {
      default: Infinity
    }
  },
  data() {
    return {
      text: ""
    };
  },
  methods: {
    remove(i) {
      this.value.splice(i, 1);
    },
    add() {
      let event = () => {
        this.$refs.inner.innerText = this.text = this.text.trim();
        if (this.value.length < this.maxCount) {
          this.text && this.value.push(this.text);
          this.$refs.inner.innerText = this.text = "";
        }
      };
      "add" in this.$listeners ? this.$emit("add", event) : event();
    }
  }
};
</script>

<style lang="less">
.v-label-group {
  &[addable] > .v-label.add {
    display: inline-flex;
  }
  > .v-label.add {
    display: none;
    > .inner {
      height: 24px;
      outline: none;
      min-width: 60px;
      line-height: 24px;
      &:empty[placeholder]::before {
        color: #808080;
        content: attr(placeholder);
      }
    }
  }
}
</style>
